import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export interface OfflineQueueItem {
  id: string;
  kind: 'note.upsert' | 'task.upsert' | 'watchlist.add-company';
  payload: Record<string, unknown>;
  createdAt: string;
}

interface OfflineQueueState {
  items: OfflineQueueItem[];
  enqueue: (item: OfflineQueueItem) => void;
  remove: (id: string) => void;
  clear: () => void;
}

const safeStorage =
  typeof window !== 'undefined'
    ? createJSONStorage(() => window.localStorage)
    : undefined;

export const useOfflineQueueStore = create<OfflineQueueState>()(
  persist(
    (set) => ({
      items: [],
      enqueue: (item) =>
        set((state) => ({
          items: [...state.items, item],
        })),
      remove: (id) =>
        set((state) => ({
          items: state.items.filter((item) => item.id !== id),
        })),
      clear: () => set({ items: [] }),
    }),
    {
      name: 'nordiccompanyhub-offline-queue',
      storage: safeStorage,
    },
  ),
);

